import { get } from "../common/http.services";

export function getLogs(searchText: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return get(`/logging?searchText=${searchText}&page=${pageNumber}&size=${pageSize}&sort=date,desc`, appContext, success, error);
}

